import React from 'react';
import { MarkerData } from 'types/maps.consts';
import './location-icon.scss';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

interface Props {
	setMapMarker: (marker: MarkerData) => void;
	lat: number;
	lng: number;
}

const LocationIcon: React.FC<Props> = ({ setMapMarker, lat, lng }) => {
	const createMapMarkerAndFocus = (lat: number, lng: number): void => {
		const marker = {
			id: 'marker-location-icon',
			location: { lng, lat }
		};
		setMapMarker(marker);
	};

	return (
		<span className="location-link" onClick={() => createMapMarkerAndFocus(lat, lng)}>
			<BringgIcon iconName={BringgFontIcons.Navigation} className="location-link-icon" />
		</span>
	);
};

export default LocationIcon;
